import Radio from "backbone.radio";
import DataTableConfigurator from "../../common/datatable-configurator";
import CustomizeView from "../../views/report-customization";
import { createModal } from "../../utils";

const channel = Radio.channel("report");

const Mixin = (superclass) =>
  class extends superclass {
    onShow() {
      // get custom report configuration, if it exists
      const preferences = channel.request(
        "preferences:find",
        this.model.get("route")
      );

      // get navigation
      let navigation = this.model.get("nav") || {};

      // was an endpoint passed?
      if (this.options.endpoint) {
        // override navigation
        navigation = {
          url: this.options.endpoint,
          data: this.options.params,
        };
      }

      // set up route name - used by history object
      this.route = this.model.get("route");

      // create configuration options
      const options = {
        eventName: this.configReadyEvent || "configuration-ready",
        endpoint: this.options.endpoint || null,
        route: this.route,
        routeConfig: this.options.routeConfig || null,
        navigation,
        columnModel: this.options.columnModel || null,
        customColumns: preferences ? preferences.get("columns") : null,
        customColumnsCreated: preferences ? preferences.get("_created") : null,
      };

      // console.log("Configuration Mixin::onShow options", options);

      // fire off configurator
      new DataTableConfigurator(options);

      // since we overrode lifecycle method, we need to call super
      if (super.onShow) super.onShow();
    }

    _onFiltersUpdated(filters) {
      // hide report
      // this.report.$el.fadeOut("fast");

      const nav = this.model.get("nav");

      // update original nav data with new selections
      nav.data = Object.assign({}, nav.originalData, filters);

      this.options.params = nav.data;

      // reconfigure
      this.onShow();

      // no need to call superclass on custom methods
      // if (super._onFiltersUpdated) super._onFiltersUpdated(filters);
    }

    // called from mixed-in views to activate report config modal
    _customizeView() {
      // pass report configuration from mixed-in view
      new CustomizeView({
        el: createModal(),
        reportConfig: this.reportConfig,
      });
    }

    // called from mixed-in views after report config has been updated
    _onReportingPreferencesUpdate(model) {
      // modify custom column details in mixed-in view report configuration
      this.reportConfig.customColumns = model ? model.get("columns") : null;
      this.reportConfig.customColumnsCreated = model
        ? model.get("_created")
        : null;

      // call mixed-in view's report render method
      this._renderReport(this.reportConfig);
    }

    // called when columns are reordered inline using DT's ColReorder plugin
    _onReportColumnsReordered() {
      // get custom report configuration, if it exists
      const preferences = channel.request(
        "preferences:find",
        this.model.get("route")
      );

      // modify custom column details in report configuration
      this.reportConfig.customColumns = preferences
        ? preferences.get("columns")
        : null;
      this.reportConfig.customColumnsCreated = preferences
        ? preferences.get("_created")
        : null;

      // call mixed-in view's report render method
      this._renderReport(this.reportConfig);
    }
  };

export { Mixin as default };
